The candidate has already been verified.
